import { AxiosError } from 'axios';
import { ChangeSummary } from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import { GET_PROFILE_AMENDMENT_REQUEST_DETAILS_URL } from '../../constants/apiUrls';
import { GET_PROFILE_AMENDMENT_REQUEST_DETAILS_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { ProfileAmendmentRequestsFile } from './useGetProfileAmendmentRequests';
import { ProfileAmendmentRequestStatus } from './usePutCancelProfileAmendmentRequest';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request / Response
// =============================================================================
export interface ProfileAmendmentRequestDetails {
  approverRemarks: string | null;
  content: ChangeSummary[];
  files: ProfileAmendmentRequestsFile[];
  requestDateTime: string;
  requestorName: string;
  requestorRemarks: string;
  status: ProfileAmendmentRequestStatus;
  updatedAt: string | null;
  updatedBy: string;
}

interface Input {
  onSuccess?: (res: ProfileAmendmentRequestDetails) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

// =============================================================================
// Query
// =============================================================================
export const useGetProfileAmendmentRequestDetails = ({ onError, onSuccess, uuid }: Input) => {
  const getProfileAmendmentRequestDetails = async () => {
    const res = await axiosClient.get<ProfileAmendmentRequestDetails>(
      GET_PROFILE_AMENDMENT_REQUEST_DETAILS_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
    GET_PROFILE_AMENDMENT_REQUEST_DETAILS_QUERY_KEY,
    getProfileAmendmentRequestDetails,
    {
      onSuccess,
      onError,
    }
  );
};
